declare var window: any;

// Converted as hook from apps/admin_web/assets/node_modules/flowbite/src/components/dropdown.js
const Dropdown = {
  dropdownInstance: null as any,
  hideDropdownHandler: null as (() => void) | null,
  default: {
    placement: "bottom",
    triggerType: "click",
    onShow: () => {},
    onHide: () => {},
  },
  initDropdown(this: any) {
    const targetEl = this.el;
    const triggerEl = document.querySelector(
      `[data-dropdown-toggle='${targetEl.id}']`,
    );
    const placement = triggerEl?.getAttribute("data-dropdown-placement");
    const onShow = targetEl.getAttribute("data-dropdown-on-show");
    const onHide = targetEl.getAttribute("data-dropdown-on-hide");
    this.dropdownInstance = new window.Dropdown(targetEl, triggerEl, {
      placement: placement ? placement : this.default.placement,
      onShow: onShow
        ? () => window.liveSocket.execJS(targetEl, onShow)
        : this.default.onShow,
      onHide: onHide
        ? () => window.liveSocket.execJS(targetEl, onHide)
        : this.default.onHide,
    });

    // Store handler reference for cleanup
    this.hideDropdownHandler = () => {
      this.dropdownInstance.hide();
    };

    this.el.addEventListener("hide_dropdown", this.hideDropdownHandler);
  },
  cleanupDropdown(this: any) {
    // Remove event listener to prevent accumulation
    if (this.hideDropdownHandler) {
      this.el.removeEventListener("hide_dropdown", this.hideDropdownHandler);
    }
    // Destroy existing dropdown instance
    if (this.dropdownInstance) {
      try {
        this.dropdownInstance.destroyAndRemoveInstance();
      } catch (_e) {
        // Instance may already be destroyed
      }
    }
  },
  mounted(this: any) {
    this.initDropdown();

    this.handleEvent("show_dropdown", ({ id }: any) => {
      id === this.el.id && this.dropdownInstance.show();
    });
  },
  updated(this: any) {
    // Clean up old instance before re-initializing
    this.cleanupDropdown();
    this.initDropdown();
  },
  destroyed(this: any) {
    this.cleanupDropdown();
  },
};

export default Dropdown;
